<mat-card class="content-card">

  <h3>Payment report - annual fee</h3>

  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px">
        <mat-form-field>
          <mat-label>Brand</mat-label>
          <mat-select [formControl]="companySelect" (selectionChange)="onCompanyChange()">
            <mat-option  *ngFor="let company of companies"
                         [value]="company.id">
              {{company.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel"
                       [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
        <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel"
                       [(ngModel)]="table.filters.endFilterDate"></app-date-edit>
        <mat-form-field class="date-filter-field">
          <mat-select placeholder="Date filters" [(ngModel)]="table.filters.dateFilterCols" multiple>
            <mat-option *ngFor="let dateFilter of dateFiltersList" [value]="dateFilter.name">
              {{dateFilter.header}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Bill Amount >=" appTwoDigitDecimaNumber
                 [(ngModel)]="table.filters.additionalValue2">
        </mat-form-field>
        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Bill Amount <=" appTwoDigitDecimaNumber
                 [(ngModel)]="table.filters.additionalValue1">
        </mat-form-field>


        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                 [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()"
                [disabled]="startDateFilter.invalid || endDateFilter.invalid">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="table.clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>



      </div>
    </div>
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table" style="margin-right: 60px;">
        <button mat-raised-button color="blue" (click)="downloadAttachment()">
          <mat-icon>download</mat-icon> Download
        </button>
      </div>
    </div>
  </div>

  <!--
  <div fxLayout="column">
    <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-start center">



      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
        <mat-form-field style="width: 400px;" class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                 [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>

  </div>
  -->

  <app-mat-table-generator #table
      tableName = "invoiceReportTable"
      [useEmbededFilter]="false"
      [columns] ="columns"
      [dataSource] ="dataSource"
      [viewLink]="null"
      [deleteEnabled]="false"
      [multiselectEnabled]="false"
  >
  </app-mat-table-generator>
</mat-card>
